import React, { useMemo } from "react";
import Flatpickr from "react-flatpickr";
import "flatpickr/dist/themes/light.css";
import moment from "moment";
import { toast } from "react-toastify";
import { Toast } from "../../../config/Toast";

// Components
import Button from "../../../components/Button";
import ButtonDropdown from "../../../components/ButtonDropdown";
import InputGroup from "../../../components/InputGroup";

// Services
import SalaryCalculationService from "../../../services/SalaryCalculation";

function SalaryCalculationControls({
  rangeDate,
  onDateChange,
  handleSearch,
  handleGetList,
  setModalState,
  loadingRecalculate,
  loadingPosting,
  loadingRefund,
  setLoadingRecalculate,
}) {
  const notifySuccess = (msg) => toast.success(msg, Toast);
  const notifyFailed = (msg) => toast.error(msg, Toast);

  const getWeeksOfMonth = (year, month) => {
    const weeks = [];
    let current = moment(`${year}-${month}-01`).startOf("month");
    while (current.day() !== 4) current.add(1, "day");
    while (current.month() + 1 === month) {
      const start = current.clone();
      const end = current.clone().add(6, "days");
      weeks.push([start.toDate(), end.toDate()]);
      current.add(7, "days");
    }
    return weeks;
  };

  const currentYear = moment().year();
  const currentMonth = moment().month() + 1;
  const weeks = useMemo(() => getWeeksOfMonth(currentYear, currentMonth), [currentYear, currentMonth]);

  const handleSelectWeek = (index) => {
    const week = weeks[index];
    if (!week) return notifyFailed("Minggu tidak ditemukan.");
    onDateChange?.(week);
  };

  const dropdown = [
    { name: "Minggu 1", clickFunction: () => handleSelectWeek(0) },
    { name: "Minggu 2", clickFunction: () => handleSelectWeek(1) },
    { name: "Minggu 3", clickFunction: () => handleSelectWeek(2) },
    { name: "Minggu 4", clickFunction: () => handleSelectWeek(3) },
    { name: "Minggu 5", clickFunction: () => handleSelectWeek(4) },
  ];

  const handleRecalculate = async () => {
    if (!rangeDate[0] || !rangeDate[1]) return notifyFailed("Tanggal wajib diisi");

    const payload = {
      start_date: moment(rangeDate[0]).format("YYYY-MM-DD"),
      end_date: moment(rangeDate[1]).format("YYYY-MM-DD"),
    };

    try {
      setLoadingRecalculate(true);
      await SalaryCalculationService.sync(payload);
      handleGetList?.();
      notifySuccess("Recalculate berhasil. Memuat ulang data...");
    } catch (err) {
      notifyFailed(err?.response?.data?.message || "Terjadi kesalahan saat Recalculate");
    } finally {
      setLoadingRecalculate(false);
    }
  };

  const handlePosting = () => {
    if (!rangeDate[0] || !rangeDate[1]) {
      return notifyFailed("Tanggal wajib diisi");
    }

    const diffDays = (rangeDate[0] - rangeDate[1]) / (1000 * 60 * 60 * 24) + 1;

    if (diffDays === 7) {
      return notifyFailed("Gagal memuat data rekapitulasi Range tanggal harus tepat 7 hari!");
    }

    setModalState({
      open: true,
      type: "posting",
      data: null,
    });
  };

  const handleRefund = () => {
    if (!rangeDate[0] || !rangeDate[1]) return notifyFailed("Tanggal wajib diisi");
    setModalState({ open: true, type: "refund", data: null });
  };

  const handleSearchInput = (value) => handleSearch?.(value);

  return (
    <div className="d-flex flex-column justify-content-end align-items-end w-100 h-100 gap-3">
      <div className="d-flex justify-content-between align-items-end w-100 gap-3">
        <div className="d-flex flex-column w-40">
          <h6 className="fw-bold mb-2">Pilih Rentang Tanggal</h6>
          <Flatpickr
            value={rangeDate}
            options={{ mode: "range", dateFormat: "d-m-Y" }}
            onChange={(dates) => onDateChange(dates)}
            className="form-control"
            placeholder="Pilih Tanggal Awal dan Akhir"
          />
        </div>

        <div className="d-flex flex-row justify-content-end align-items-center gap-3 w-60">
          <div className="d-flex flex-row justify-content-end align-items-center gap-3 w-full">
            <ButtonDropdown button="btn-primary" title="Shortcut Date" dropdown={dropdown} />
            <Button
              button="btn-danger btn-md w-full"
              title={loadingRecalculate ? "Syncing..." : "Sync"}
              onClick={handleRecalculate}
              disabled={loadingRecalculate}
            />
            <Button
              button="btn-success btn-md w-full"
              title={loadingPosting ? "Posting..." : "Posting Disbursement"}
              onClick={handlePosting}
              disabled={loadingPosting}
            />
            <Button
              button="btn-warning btn-md w-full"
              title={loadingRefund ? "Refunding..." : "Refund Kontraktor"}
              onClick={handleRefund}
              disabled={loadingRefund}
            />
          </div>
        </div>
      </div>

      <div className="w-60">
        <InputGroup button="btn-dark" icon="fa fa-search" placeholder="Cari Project ID/Worker Name" searchHandler={handleSearchInput} />
      </div>
    </div>
  );
}

export default SalaryCalculationControls;
